(function ($, ko) {

    // for AccountsSummaryMini widget
    ko.bindingHandlers.chartAccountBalanceColumn = {
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {

            function createColumn(val, percent) {
                function createSpan(val) {
                    var currency = $.cdh.helper.parseCurrency(val);
                    var html = '$' + currency.beforeDot + '.' + currency.afterDot;
                    if (currency.negative) {
                        html = "(" + html + ")";
                    }
                    if (!account.HideDollarAmount) {
                        html = '<span class="currency-span">' + html + '</span>';
                    } else {
                        html = '';
                    }
                    return html;
                }
                if (!account.HideDollarAmount) {
                    return '<div class="b-dashboard-accounts-chart-total-col" style="width: ' + percent + '%">' + createSpan(val) + '</div>';
                }
                return '<div class="b-dashboard-accounts-chart-total-col" style="width: ' + percent + '%"> </div>';
            }

            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;

            var dataElement = {AvailableBalance: account.AvailableBalance + account.PortfolioBalance != 0 ? account.AvailableBalance : 0.001};
            if (dataElement.AvailableBalance < 0) {
                dataElement.AvailableBalance = 0.001;
            }

            var firstSerieLabelsVisible = true;
            var secondSerieLabelsVisible = true;
            if (account.AccountType === $.cdh.enums.accountType.hsa) {
                dataElement.PortfolioBalance = account.PortfolioBalance;
                if (dataElement.PortfolioBalance < 0) {
                    dataElement.PortfolioBalance = 0.001;
                }
                firstSerieLabelsVisible = false;
                secondSerieLabelsVisible = false;
            } else {
                dataElement.AvailableBalanceLabel = !account.accountIntervalType() ? account.FieldsAliases.Balance?.Title : account.FieldsAliases.IntervalBalance?.Title;
                if(!dataElement.AvailableBalanceLabel) {
                    dataElement.AvailableBalance = 0;
                }
                dataElement.PortfolioBalance = !account.FieldsAliases.Balance && account.Spent === 0 ? 0.001 : account.Spent;

                if (account.accountIntervalType()) {
                    dataElement.AvailableBalance = account.currentIntervalBalance();
                    dataElement.PortfolioBalance = account.currentIntervalDisbursed() === 0 ? 0.001 : account.currentIntervalDisbursed();
                }

                //If this is account is parking or transit - set Spent as 0 (there should be only Available Balance)
                if (account.AccountType == $.cdh.enums.accountType.parking || account.AccountType == $.cdh.enums.accountType.transit || (!account.accountIntervalType() && !account.FieldsAliases.Spent)) dataElement.PortfolioBalance = dataElement.AvailableBalance == 0 ? 0.001 : 0;
                firstSerieLabelsVisible = true;
            }

            var $el = $(element);
            var lval = dataElement.AvailableBalance;
            var rval = dataElement.PortfolioBalance;
            var total = lval + rval;

            $el.closest('.b-dashboard-accounts-chart').find('.b-dashboard-accounts-chart-total').append(
                '<div class="b-dashboard-accounts-chart-total-columns">' +
                ((firstSerieLabelsVisible == true) ? createColumn(total, 100) : '') +
                '</div>');
            firstSerieLabelsVisible = false;
            secondSerieLabelsVisible = false;

            //horizontal column chart rendering
            var chartData = {
                element: element,
                colorScheme:
                    account.AccountType == $.cdh.enums.accountType.hsa ? 'account-balance-column-hsa' :
                        account.AccountType == $.cdh.enums.accountType.fsa ?
                            (account.EnableAccountDormancy ? 'account-balance-column-hra-dormant' : 'account-balance-column-fsa') :
                            account.EnableAccountDormancy ? 'account-balance-column-hra-dormant' : 'account-balance-column-hra',
                padding: {left: 0, top: 0, right: 0, bottom: 0},
                valueAxis: {visible: false},
                dataArr: [dataElement],
                seriesGroups: [{
                    showToolTips: false,
                    type: 'stackedcolumn100',
                    columnsGapPercent: 0,
                    seriesGapPercent: 0,
                    columnsMaxWidth: 40,
                    columnsMinWidth: 40,
                    orientation: 'horizontal',
                    useGradientColors: false,
                    xAxis: {visible: false},
                    valueAxis: {
                        visible: false,
                        flip: true,
                        displayValueAxis: false,
                        description: '',
                        axisSize: 'auto',
                        tickMarksColor: '#888888'
                    },
                    series: [
                        {
                            dataField: 'AvailableBalance',
                            displayText: account.HsaAdvAccessibilityFlag ? $.cdh.languageConstant.getConstant('AccountMiniItem.lblBalance') : $.cdh.languageConstant.getConstant('AccountMiniItem.lblAvailableCash'),
                            lineWidth: 0,
                            formatSettings: {prefix: '$', decimalPlaces: 2},
                            labels: {
                                visible: firstSerieLabelsVisible,
                                offset: {x: 0, y: 0},
                                verticalAlignment: 'middle',
                                class: 'b-dashboard-accounts-chart-total'
                            },
                            toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                                return $.cdh.languageConstant.getConstant('AccountMiniItem.lblAvailableCash') +': $' + value;
                            }
                        },
                        {
                            dataField: 'PortfolioBalance',
                            displayText: $.cdh.languageConstant.getConstant('AccountMiniItem.lblInvestmentBalance'),
                            lineWidth: 0,
                            formatSettings: {prefix: '$', decimalPlaces: 2},
                            labels: {
                                visible: secondSerieLabelsVisible,
                                offset: {x: 0, y: 0},
                                verticalAlignment: 'middle',
                                class: 'b-dashboard-accounts-chart-total'
                            },
                            toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                                return $.cdh.languageConstant.getConstant('AccountMiniItem.lblInvestmentBalance')+': $' + value;
                            }
                        }
                    ]
                }

                ]
            };

            $.cdh.charts.bindStackedColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartAccountBalanceColorAvailable = {
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;
            var color =
                account.AccountType === $.cdh.enums.accountType.hsa ? $.cdh.brandData.ChartHsaAvailableColor :
                    account.AccountType === $.cdh.enums.accountType.fsa ?
                        (account.EnableAccountDormancy ? $.cdh.brandData.ChartHraDormantPrimary : $.cdh.brandData.ChartFsaAvailableColor) :
                        account.EnableAccountDormancy ? $.cdh.brandData.ChartHraDormantPrimary :
                            $.cdh.brandData.ChartHraAvailableColor;

            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '0');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    };

    ko.bindingHandlers.chartAccountBalanceColor2 = {
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;
            var color =
                account.AccountType === $.cdh.enums.accountType.hsa ? $.cdh.brandData.ChartHsaInvestmentColor :
                    account.AccountType === $.cdh.enums.accountType.fsa ?
                        (account.EnableAccountDormancy ? $.cdh.brandData.ChartHraDormantSecondary : $.cdh.brandData.ChartFsaSpentColor) :
                        account.EnableAccountDormancy ? $.cdh.brandData.ChartHraDormantSecondary :
                            $.cdh.brandData.ChartHraSpentColor;

            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '1');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    };

    ko.bindingHandlers.chartHoldsColor = {
        update: function (element, valueAccessor) {

            var color = "#CA8531";

            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '2');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    // for AccountsSummary and AccountsDetails widgets
    ko.bindingHandlers.chartAccountBalanceDonut = {
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;

            var dataElement = {
                AvailableBalance: account.AvailableBalance + account.PortfolioBalance != 0 ? account.AvailableBalance : 0.001,
                AvailableBalanceLabel: account.EnableAccountDormancy ? $.cdh.languageConstant.getConstant('AccountSummaryItemHSA.lblDormantBal') :
                    account.HsaAdvAccessibilityFlag ? $.cdh.languageConstant.getConstant('AccountSummaryItemHSA.lblBalance') : $.cdh.languageConstant.getConstant('AccountSummaryItemHSA.lblAvailableCash')
            };
            if (account.AccountType === $.cdh.enums.accountType.hsa) {
                dataElement.PortfolioBalance = account.PortfolioBalance;
                dataElement.PortfolioBalanceLabel = account.HsaAdvAccessibilityFlag ? $.cdh.languageConstant.getConstant('AccountSummaryItemHSA.btnHSAAdvance') : $.cdh.languageConstant.getConstant('AccountSummaryItemHSA.lblInvestmentBal');
                dataElement.Holds = account.Holds;
            } else {
                dataElement.AvailableBalanceLabel = !account.accountIntervalType() ? account.FieldsAliases.Balance?.Title : account.FieldsAliases.IntervalBalance?.Title;
                if(!dataElement.AvailableBalanceLabel) {
                    dataElement.AvailableBalance = 0;
                }

                dataElement.PortfolioBalance = !account.FieldsAliases.Balance && account.Spent === 0 ? 0.001 : account.Spent;

                if (account.accountIntervalType()) {
                    dataElement.AvailableBalance = account.currentIntervalBalance();
                    dataElement.PortfolioBalance = account.currentIntervalDisbursed() === 0 ? 0.001 : account.currentIntervalDisbursed();
                }

                //If this is account is parking or transit - set Spent as 0 (there should be only Available Balance)
                if (account.AccountType == $.cdh.enums.accountType.parking || account.AccountType == $.cdh.enums.accountType.transit || (!account.accountIntervalType() && !account.FieldsAliases.Spent)) dataElement.PortfolioBalance = dataElement.AvailableBalance == 0 ? 0.001 : 0;
                dataElement.PortfolioBalanceLabel = !account.accountIntervalType() ? account.FieldsAliases.Spent?.Title : account.FieldsAliases.IntervalSpent?.Title;
            }

            var dataArr = account.AccountType == $.cdh.enums.accountType.hsa ? [{
                "label": dataElement.PortfolioBalanceLabel,
                "value": dataElement.PortfolioBalance
            },
            {
                "label": dataElement.AvailableBalanceLabel,
                "value": dataElement.AvailableBalance
            },
            {
                "label": $.cdh.languageConstant.getConstant('AccountSummaryItemHSA.lblHolds'),
                "value": dataElement.Holds
            }] :
                [{
                    "label": dataElement.PortfolioBalanceLabel,
                    "value": dataElement.PortfolioBalance
                },
                {
                    "label": dataElement.AvailableBalanceLabel,
                    "value": dataElement.AvailableBalance
                }];


            var chartData = {
                element: element,
                colorScheme:
                    account.AccountType == $.cdh.enums.accountType.hsa ? 'account-balance-donut-hsa' :
                        account.AccountType == $.cdh.enums.accountType.fsa ?
                            (account.EnableAccountDormancy ? 'account-balance-donut-hra-dormant' : 'account-balance-donut-fsa') :
                            account.EnableAccountDormancy ? 'account-balance-donut-hra-dormant' : 'account-balance-donut-hra',
                dataArr: dataArr
            };

            $.cdh.charts.bindDonutChart(chartData);
        }
    };

    // for AccountsDetailsNonHsa widget
    ko.bindingHandlers.chartAccountAnnualContribution = {
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {
            var data = ko.unwrap(valueAccessor());
            if (!data) return;
            var labelsArr = data.AccountType == $.cdh.enums.accountType.hra ? [$.cdh.languageConstant.getConstant('AccountDetail.lblAllocatedFar'), $.cdh.languageConstant.getConstant('AccountDetail.lblRemainingAllocation')] : [$.cdh.languageConstant.getConstant('AccountDetail.lblPayrollDepositsYTD'), $.cdh.languageConstant.getConstant('AccountDetail.lblRemainingPayrollDeposits')];
            //stacked column chart rendering
            var chartData = {
                element: element,
                colorScheme: data.AccountType == $.cdh.enums.accountType.fsa
                    ? 'account-annual-contribution-fsa'
                    : 'account-annual-contribution-hra',
                dataArr: [data],
                labelsArr: labelsArr
            };

            $(element).on('refreshEnd', function () {
                setTimeout(function () {
                    $.cdh.helper.buildContributionChartLabels(element, chartData, {
                        topValue: chartData.dataArr[0].RemainingContributions,
                        bottomValue: chartData.dataArr[0].ContributionsYTD
                    });
                }, 1000);
            });

            //create the chart
            $.cdh.charts.bindStackedColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartAccountAnnualContributionColorContributedSoFar = {
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;

            var hraColorAccountTypes = [$.cdh.enums.accountType.hra, $.cdh.enums.accountType.parking, $.cdh.enums.accountType.transit];
            var color = _.includes(hraColorAccountTypes, account.AccountType)
                ? $.cdh.brandData.ChartHraContributedSoFarColor
                : $.cdh.brandData.ChartFsaContributedSoFarColor;

            $(element).css('background', color);
            $(element).css('opacity', 0.7);
        }
    }

    ko.bindingHandlers.chartAccountAnnualContributionColorRemaining = {
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;

            var hraColorAccountTypes = [$.cdh.enums.accountType.hra, $.cdh.enums.accountType.parking, $.cdh.enums.accountType.transit];
            var color = _.includes(hraColorAccountTypes, account.AccountType)
                ? $.cdh.brandData.ChartHraRemainingToContributeColor
                : $.cdh.brandData.ChartFsaRemainingToContributeColor;

            $(element).css('background', color);
            $(element).css('opacity', 0.7);
        }
    }

})(jQuery, ko);
